import { Clock3, Edit3, Power, Printer, Users } from 'lucide-react';

import { RestaurantPreparationStationDTO } from '../../../../types/restaurant/RestaurantPreparationStationTypes';

interface PreparationStationCardProps {
  station: RestaurantPreparationStationDTO;
  onEdit: (station: RestaurantPreparationStationDTO) => void;
  onDeactivate: (station: RestaurantPreparationStationDTO) => void;
  onManageAssignments: (station: RestaurantPreparationStationDTO) => void;
}

const PreparationStationCard = ({
  station,
  onEdit,
  onDeactivate,
  onManageAssignments,
}: PreparationStationCardProps) => {
  return (
    <article
      className={`rounded-xl border border-stroke bg-white p-5 transition hover:border-primary/30 hover:shadow-card dark:border-strokedark dark:bg-boxdark ${
        station.active ? '' : 'opacity-60'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary">
            {station.code}
          </span>

          <h3 className="mt-1 truncate font-semibold text-black dark:text-white">
            {station.name}
          </h3>
        </div>

        <span
          className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-medium ${
            station.active && station.enabled
              ? 'bg-success/10 text-success'
              : station.active
              ? 'bg-warning/10 text-warning'
              : 'bg-danger/10 text-danger'
          }`}
        >
          {station.active
            ? station.enabled
              ? 'Operativa'
              : 'Pausada'
            : 'Inactiva'}
        </span>
      </div>

      <div className="mt-5 space-y-3 text-sm">
        <div className="flex items-center gap-2 text-bodydark2 dark:text-bodydark">
          <Printer className="h-4 w-4" />
          <span>{station.printerName || 'Sin impresora asignada'}</span>
        </div>

        <div className="flex items-center gap-2 text-bodydark2 dark:text-bodydark">
          <Clock3 className="h-4 w-4" />
          <span>
            {station.estimatedPreparationMinutes
              ? `${station.estimatedPreparationMinutes} minutos estimados`
              : 'Sin tiempo estimado'}
          </span>
        </div>

        {station.description && (
          <p className="line-clamp-2 border-t border-stroke pt-3 text-bodydark2 dark:border-strokedark dark:text-bodydark">
            {station.description}
          </p>
        )}
      </div>

      <div className="mt-5 grid grid-cols-2 gap-2 border-t border-stroke pt-4 dark:border-strokedark">
        <button
          type="button"
          onClick={() => onManageAssignments(station)}
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-stroke px-3 py-2 text-sm font-medium transition hover:border-primary hover:bg-primary/5 hover:text-primary dark:border-strokedark"
        >
          <Users className="h-4 w-4" />
          Responsables
        </button>

        <button
          type="button"
          onClick={() => onEdit(station)}
          className="inline-flex items-center justify-center gap-2 rounded-xl border border-stroke px-3 py-2 text-sm font-medium transition hover:border-primary hover:bg-primary/5 hover:text-primary dark:border-strokedark"
        >
          <Edit3 className="h-4 w-4" />
          Editar
        </button>

        {station.active && (
          <button
            type="button"
            onClick={() => onDeactivate(station)}
            className="col-span-2 inline-flex items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-medium text-danger transition hover:bg-danger/5"
          >
            <Power className="h-4 w-4" />
            Desactivar
          </button>
        )}
      </div>
    </article>
  );
};

export default PreparationStationCard;
